import { Button } from "@/components/ui/button";
import { FileText, FolderPlus, Search, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface ActionButtonsProps {
  onCreateDocument: () => void;
  onCreateCase: () => void;
  onLawSearch: () => void;
  isGenerating: boolean;
  canShowActions: boolean;
  className?: string;
}

export function ActionButtons({
  onCreateDocument,
  onCreateCase,
  onLawSearch,
  isGenerating,
  canShowActions,
  className
}: ActionButtonsProps) {
  if (!canShowActions) return null;

  return (
    <div className={cn(
      "p-4 space-y-3 bg-white/50 backdrop-blur-sm border rounded-lg",
      "w-full md:w-auto",
      className
    )}>
      <Button
        onClick={onCreateDocument}
        disabled={isGenerating}
        variant="outline"
        className={cn(
          "w-full min-h-[48px]",
          "bg-white hover:bg-gray-50",
          "border-2 border-[#FF6A00] text-[#FF6A00]",
          "flex items-center gap-2",
          "transition-colors duration-200"
        )}
      >
        {isGenerating ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <FileText className="h-4 w-4" />
        )}
        <span>{isGenerating ? "Genererer..." : "Generer dokument"}</span>
      </Button>

      <Button
        onClick={onCreateCase}
        variant="outline"
        className={cn(
          "w-full min-h-[48px]",
          "bg-white hover:bg-gray-50",
          "border-2 border-[#FF6A00] text-[#FF6A00]",
          "flex items-center gap-2",
          "transition-colors duration-200"
        )}
      >
        <FolderPlus className="h-4 w-4" />
        <span>Opprett sak</span>
      </Button>

      <Button
        onClick={onLawSearch}
        variant="outline"
        className={cn(
          "w-full min-h-[48px]",
          "bg-white hover:bg-gray-50",
          "border-2 border-[#FF6A00] text-[#FF6A00]",
          "flex items-center gap-2",
          "transition-colors duration-200"
        )}
      >
        <Search className="h-4 w-4" />
        <span>Søk i lover</span>
      </Button>
    </div>
  );
}